import { AnyPlan, DigitalEntry } from '../../types';

export type GetCountryDataFn = (plan: AnyPlan, country: string) => any;

export const getScenarios = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => getCountryData(plan, country)?.campaignScenario ?? 'N/A');

export const getTargetGroups = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => getCountryData(plan, country)?.targetGroup ?? 'N/A');

export const getSegmentsJoined = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): string[] =>
  plans.map((plan) => {
    const segs = getCountryData(plan, country)?.segments ?? [];
    return segs.length ? segs.map((s: any) => s.title).join('\n') : 'N/A';
  });

export type DigitalBudgetTotal = {
  sum: number;
  currency?: string;
};

export const getDigitalBudgetTotals = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
): DigitalBudgetTotal[] =>
  plans.map((plan) => {
    const c = getCountryData(plan, country);
    const digital: DigitalEntry[] = c?.calculatedBudget ?? [];

    let sum = 0;
    let currency: string | undefined;

    digital.forEach((e) => {
      const val = e?.budget?.value;
      if (typeof val === 'number') {
        sum += val;
        if (!currency && e.budget?.currency) {
          currency = e.budget.currency;
        }
      }
    });

    return { sum, currency };
  });

export const getDigitalBudgetSums = (totals: DigitalBudgetTotal[]): number[] =>
  totals.map((d) => d.sum);

export const getDigitalBudgetData = (
  plans: AnyPlan[],
  country: string,
  getCountryData: GetCountryDataFn
) => {
  const totals = getDigitalBudgetTotals(plans, country, getCountryData);
  const sums = getDigitalBudgetSums(totals);
  return { totals, sums };
};
